import React from 'react';
import { Box, Typography } from '@mui/material';
import './FifthSection.scss';
import Unlimitedmusicsign from '../../../assets/Images/white Unlimited music sign.svg';
import FacebookIcon from '../../../assets/Images/fb logo.svg';
import LinkedInIcon from '../../../assets/Images/linkedin-icon.svg';
import TikTokIcon from '../../../assets/Images/tiktok-icon.svg'
import Boomplay from '../../../assets/Images/boomplay.svg'
import firstNum from '../../../assets/Images/firstNum.svg';
import LineMusic from '../../../assets/Images/line music.svg';
import tencentmusic from '../../../assets/Images/tencent music.svg';
import Tidal from '../../../assets/Images/Tidal.svg'
import UnifiedButton from '../../shared/Button';
import secondNum from '../../../assets/Images/2.svg'
import applemusic from '../../../assets/Images/apple-music-icon.svg';
import jiosavan from '../../../assets/Images/jio savan.svg'
import amazonmusic from '../../../assets/Images/amazon music.svg';
import suportIcon from '../../../assets/Images/Support for Artists in Video Distribution.svg'
import { Slide } from 'react-awesome-reveal';
import { useNavigate } from 'react-router-dom';

function FifthSection() {

    const navigate = useNavigate()
    const handleplaylistformClick = () => {
        console.log('Navigating to /pricing');
        navigate('/support/legal-forms/0');
        window.scrollTo(0, 0);
    };
    return (
        <Box className="fifth-section">
            <Box className="content-container">
                <Slide direction="up" triggerOnce duration={1000} delay={200}>
                    <Box className="fifth-header">
                        <img src={Unlimitedmusicsign} alt="Support Icon" className="icon" />
                        <img src={suportIcon} alt="Support Icon" className="support-icon" />
                        <Typography variant="h4" component="h2" className="section-title">
                            Support for Artists in Video Distribution and Production
                        </Typography>
                    </Box>

                    <Box className="content">
                        <Box className="logos-container">
                            <div className="circle">
                                <img src={FacebookIcon} alt="Facebook" className="logo-icon" />
                                <img src={TikTokIcon} alt="TikTok" className="logo-icon" />
                                <img src={tencentmusic} alt="tencentmusic" className="logo-icon" />
                                <img src={LineMusic} alt="LineMusic" className="logo-icon" />
                                <img src={Boomplay} alt="Boomplay" className="logo-icon" />
                                <img src={Tidal} alt="Tidal" className="logo-icon" />
                                <img src={applemusic} alt="applemusic" className="logo-icon" />
                                <img src={jiosavan} alt="jiosavan" className="logo-icon" />
                                <img src={amazonmusic} alt="amazonmusic" className="logo-icon" />

                            </div>
                        </Box>

                        <Box className="text-content">
                            <Typography sx={{ display: 'flex', justifyContent: 'flex-end', maxWidth: '600px' }} variant="h5" component="h3" className='subsection-title'>
                                <img src={firstNum} alt="Support Icon" style={{ width: '30px', display: 'flex', justifyContent: 'flex-end' }} />
                                Enhance Your Video Content
                            </Typography>
                            <ul className="enhance-video-content">
                                <li>
                                    <div className="bullet">
                                        •

                                        <Typography variant="h6">Video Distribution</Typography>
                                    </div>
                                    <div className="text">
                                        {/* <Typography variant="h6">Video Distribution</Typography> */}
                                        <Typography variant="body2">
                                            Distribute your music videos through FM Digital Official to platforms like Vevo, showcasing your artistry to a wider audience.
                                        </Typography>
                                    </div>
                                </li>
                                <li>
                                    <div className="bullet">•
                                        <Typography variant="h6">YouTube Content ID</Typography>

                                    </div>
                                    <div className="text">

                                        <Typography variant="body2">
                                            Protect your work by identifying other videos using your content and claiming the royalties you're owed as a copyright owner.
                                        </Typography>
                                    </div>
                                </li>
                                <li>
                                    <div className="bullet">•
                                        <Typography variant="h6">Official Artist Channel</Typography>
                                    </div>
                                    <div className="text">

                                        <Typography variant="body2">
                                            Apply for an official artist channel to ensure your fans are accessing legitimate content directly from you.
                                        </Typography>
                                    </div>
                                </li>
                            </ul>
                            {/* <Typography variant="h5" component="h3" className="subsection-title">
                            <img src={secondNum} alt="Support Icon" style={{ width: '30px' }} /> Enhance Your Video Content
                        </Typography>
                        <Typography variant="body2" className="additional-content">
                            If you have great audio content and a potential sponsor but need help producing a high-quality music video, the FM Digital Official team is ready to bring your vision to life.
                        </Typography>
                        <UnifiedButton variant="contained" className="cta-button" textContent="Simply fill out this form." /> */}
                        </Box>

                    </Box>


                    <Box className="fifth-section-second-box">
                        <Typography variant="h5" component="h3" className="subsection-title">
                            <img src={secondNum} alt="Support Icon" style={{ width: '30px' }} /> Enhance Your Video Content
                        </Typography>
                        <Typography variant="body2" className="additional-content">
                            If you have great audio content and a potential sponsor but need help producing a high-quality music video, the FM Digital Official team is ready to bring your vision to life.
                        </Typography>
                        <Box className="fifth-section-second-btn">
                            <UnifiedButton onClick={handleplaylistformClick} className="cta-button" textContent="Simply fill out this form." />
                        </Box>
                    </Box>
                </Slide>
            </Box>

        </Box>
    );
}

export default FifthSection;
